<!-- eslint-disable @angular-eslint/template/prefer-contextual-for-variables -->
<h1>Legal content manager</h1>
    
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <label>
    <input type="checkbox" formControlName="overridden" />
    Override
  </label>

  @if (form.get('overridden')?.value) {
    <div>
      <a href="https://cloudconvert.com/pdf-to-html" target="_blank">Convert PDF to HTML</a>
      <div formArrayName="items">
        @for (item of items.controls; track item; let idx = $index) {
          <div>
            <div [formGroupName]="idx">
              <div class="row">
                <input placeholder="Title" formControlName="title" />
              </div>
              <div class="row">
                <textarea placeholder="HTML Content" formControlName="htmlContent"></textarea>
              </div>
              <button type="button" (click)="deleteItem(idx)">Delete</button>
              <button type="button" (click)="moveUp(idx)">Move Up</button>
              <button type="button" (click)="moveDown(idx)">Move Down</button>
            </div>
          </div>
        }
      </div>
      <button type="button" (click)="addItem()">Add Item</button>
    </div>
  }

  <button type="submit">Save</button>
</form>
